<template>
  <div class="list-box">
    <div class="nav gap-x-3" title="KeHuList" data-title="联系人">
      <el-input
        v-model="state.params.keywords"
        class="c-search-white"
        clearable
        placeholder="关键字"
        @keyup.enter="onLoad()"
        @clear="onLoad()"
      >
        <template #suffix>
          <el-icon
            @click="onLoad()"
            color="#a2a2a2"
            title="搜索"
            class="font-bold cursor-pointer hover:opacity-60"
            ><Search
          /></el-icon>
        </template>
      </el-input>
      <el-button
        type="primary"
        icon="Plus"
        @click="
          delete state.selectId;
          state.showInfo = true;
        "
      >
        新建
      </el-button>
    </div>
    <div class="content c-table-box mt-2" v-if="state.list_data?.length > 0">
      <div class="overflow-y-auto flex flex-col gap-y-3">
        <div
          class="bg-white p-4 rounded-lg"
          v-for="item in state.list_data"
          :key="item"
        >
          <ul class="flex gap-x-3">
            <strong>{{ item.name }}</strong>
            <c_sex :value="item.title == '先生' ? '男' : '女'" />
            <text class="text-sm">{{ $phoneFormat(item.phone) }}</text>
            <c_cell title="职务" :value="item.job" />
            <c_cell title="邮箱" :value="item.email" />
            <c_cell title="微信" :value="item.wechat_number" />
            <c_cell title="备注" :value="item.remark" class="flex-1" />
            <el-button
              type="primary"
              plain
              link
              @click="
                state.selectId = item.id;
                state.showInfo = true;
              "
            >
              <template #icon>
                <el-icon :size="22" class="font-bold">
                  <Edit />
                </el-icon>
              </template>
            </el-button>
            <el-button
              type="danger"
              plain
              link
              @click="onDelete(item)"
              style="margin-left: -5px"
            >
              <template #icon>
                <el-icon :size="22" class="font-bold">
                  <Delete />
                </el-icon>
              </template>
            </el-button>
          </ul>
          <div class="flex items-center text-gray-400 text-xs gap-x-2 mt-2">
            <text class="text-sm text-gray-600">
              {{ item?.add_admin_name }}
            </text>
            <text>{{ item?.add_department_name }}</text>
            <text class="ml-1">{{ item?.create_time }} 创建</text>
          </div>
        </div>
      </div>
      <c_page
        :total="state.totalCount"
        :pageIndex="state.params.page"
        :pageSize="state.params.limit"
        @onLoad="
          (page) => {
            state.params.page = page.pageIndex;
            state.params.limit = page.pageSize;
            onLoad();
          }
        "
      />
    </div>
    <div class="text-center" v-else>
      <el-image :src="require('@/assets/images/nodata.png')" />
    </div>
  </div>
  <el-dialog
    v-model="state.showInfo"
    :title="state.selectId ? '编辑联系人' : '新建联系人'"
    class="c-el-dialog"
    width="500"
    :before-close="
      () => {
        state.showInfo = false;
      }
    "
  >
    <c_info
      :id="state.selectId"
      :supplier_id="props.supplier_id"
      @close="
        (refresh) => {
          state.showInfo = false;
          if (refresh) onLoad();
        }
      "
    />
  </el-dialog>
</template>

<script>
import { onMounted, reactive } from "vue";
import {
  supplier_contact_page,
  supplier_contact_delete,
} from "@/http/supplier";
import { onDeleteConfirm } from "@/utils/funcs";

import c_info from "./Info.vue";

class InitFormData {
  params = {
    page: 1,
  };
}

export default {
  props: {
    supplier_id: Number,
  },
  components: {
    c_info,
  },
  setup(props) {
    const state = reactive({
      ...new InitFormData(),
    });
    onMounted(() => {
      state.params.supplier_id = props.supplier_id;
      onLoad();
    });

    const onLoad = () => {
      delete state.bmData;

      supplier_contact_page(state.params).then((res) => {
        if (res.status == 200) {
          const { list, count } = res.data?.data;
          state.list_data = list;
          state.totalCount = count;
        }
      });
    };

    //删除
    const onDelete = (row) => {
      onDeleteConfirm(supplier_contact_delete, row.id, onLoad, {
        filed: "客户联系人",
        name: row.name,
      });
    };

    return { state, props, onLoad, onDelete };
  },
};
</script>

<style lang="scss" scoped></style>
